import React from "react";

const SECTIONS = [
  {
    title: "Qu'est-ce qu'un cookie ?",
    content:
      "Un cookie est un petit fichier texte déposé sur votre navigateur lors de votre visite sur un site internet. Il permet au site de mémoriser des informations sur votre navigation pour améliorer votre expérience.",
  },
  {
    title: "Cookies techniques (obligatoires)",
    content:
      "Ces cookies sont indispensables au fonctionnement de PixyQuiz. Ils permettent notamment de maintenir votre session de connexion, de gérer vos préférences et d'assurer la sécurité de vos échanges avec le site. Ils ne peuvent pas être désactivés.",
  },
  {
    title: "Cookies de performance et d'analyse",
    content:
      "Ces cookies nous permettent de mesurer l'audience et les performances du site (pages vues, durée de visite, erreurs techniques). Les données collectées sont anonymisées et utilisées uniquement pour améliorer le service.",
  },
  {
    title: "Cookies de personnalisation",
    content:
      "Ces cookies permettent de mémoriser vos préférences (thème, paramètres d'affichage) pour personnaliser votre expérience de jeu. Ils sont activés uniquement si vous êtes connecté.",
  },
  {
    title: "Gestion de vos préférences",
    content:
      "Vous pouvez configurer votre navigateur pour accepter ou refuser les cookies. Notez que le refus des cookies techniques peut empêcher le bon fonctionnement de PixyQuiz. Pour modifier vos préférences, consultez les paramètres de votre navigateur (Chrome, Firefox, Safari, Edge).",
  },
  {
    title: "Durée de conservation des cookies",
    content:
      "Les cookies de session sont supprimés à la fermeture de votre navigateur. Les cookies persistants sont conservés pour une durée maximale de 12 mois, conformément aux recommandations de la CNIL.",
  },
  {
    title: "Contact",
    content:
      "Pour toute question relative à l'utilisation des cookies sur PixyQuiz, vous pouvez nous contacter via la page « Contactez-nous ».",
  },
];

export default function Cookies() {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-600">
            LÉGAL
          </p>
          <h1 className="mt-3 text-4xl font-black text-slate-950">
            Politique de cookies
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {SECTIONS.map((section) => (
            <div
              key={section.title}
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
            >
              <h2 className="text-lg font-black text-slate-950">
                {section.title}
              </h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">
                {section.content}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
